// src/data/logsData.js

export const logsData = [
  {
    utilisateur: "admin@lycee-moulin.fr",
    action: "Ajout d'une classe",
    date: "2025-07-21 10:45",
  },
  {
    utilisateur: "admin@lycee-moulin.fr",
    action: "Modification des informations de l’établissement",
    date: "2025-07-21 11:12",
  },
  {
    utilisateur: "admin@lycee-moulin.fr",
    action: "Ajout d’un utilisateur (M. Lefebvre - prof)",
    date: "2025-07-22 08:30",
  },
  {
    utilisateur: "admin@lycee-moulin.fr",
    action: "Suppression d’un élève",
    date: "2025-07-22 14:12",
  },
];
